import { useCallback } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";

function useManageCategoryItem() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const manageCategoryItem = useCallback(
    ({ method, body = null, onSuccessCallback = () => {} }) => {
      if (!["POST", "PUT", "DELETE"].includes(method)) {
        showMessage({ message: `Unsupported method "${method}"` });
        return;
      }

      const operation =
        method === "POST" ? "create" : method === "PUT" ? "update" : "delete";

      fetchWrapper({
        method: method,
        endpoint_url: "category/manageCategoryItem",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        onSuccess: (fetch_output) => {
          if (fetch_output.message) {
            showMessage({ type: "success", message: fetch_output.message });
            onSuccessCallback(fetch_output.data);
          } else {
            showMessage({
              message: fetch_output.error || `An unknown error occurred.`,
            });
          }
        },
        onFetchError: () =>
          showMessage({
            apiType: "fetch",
            message: `Could not ${operation} item`,
          }),
        onResponseError: () =>
          showMessage({
            apiType: "response",
            message: `Could not ${operation} item`,
          }),
      });
    },
    [fetchWrapper, showMessage]
  );

  return { manageCategoryItem };
}

export default useManageCategoryItem;
